import { HttpRequest } from './request.ts';
import { HttpResponse } from './response.ts';

export abstract class Fetch {
	abstract fetch(url: string, options?: HttpRequest): Promise<HttpResponse>;
}
